if (!customElements.get('animated-title')) {
  class AnimatedTitle extends HTMLElement {
    constructor() {
      super();
      this.animationStarted = false;
      this.observer = null;
    }
  
    connectedCallback() {
      // Wait for content to be ready
      if (this.querySelector('.animated-title-content')) {
        this.initObserver();
      } else {
        // If content isn't ready, wait a bit
        setTimeout(() => {
          if (this.querySelector('.animated-title-content')) {
            this.initObserver();
          }
        }, 100);
      }
    }
  
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  
    initObserver() {
      const section = this.closest('.shopify-section');
      if (!section) return;
  
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.animationStarted) {
            this.startAnimation();
            this.observer.disconnect();
          }
        });
      }, { 
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      });
  
      this.observer.observe(section);
    }
  
    startAnimation() {
      if (this.animationStarted) return;
      this.animationStarted = true;
  
      const animType = this.dataset.animationType || 'number';
      const animDuration = parseFloat(this.dataset.animationDuration) || 2;
      const titleText = this.dataset.titleText || '';
      const suffix = this.dataset.suffix || '';
      const contentSpan = this.querySelector('.animated-title-content');
      
      if (!contentSpan) return;
  
      if (animType === 'number') {
        this.animateNumber(contentSpan, animDuration);
      } else if (animType === 'text') {
        this.animateText(contentSpan, titleText, animDuration);
      }
    }
  
    animateNumber(contentSpan, animDuration) {
      const firstPart = this.dataset.firstPart || '0';
      const testNumber = parseFloat(this.dataset.testNumber) || 0;
      const targetNumber = testNumber !== 0 || firstPart === '0' ? testNumber : 0;
      const hasDecimal = firstPart.includes('.');
      const decimalPlaces = hasDecimal ? firstPart.split('.')[1].length : 0;
      
      let currentNumber = 0;
      const startTime = Date.now();
      const duration = animDuration * 1000;
      
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function (ease-out)
        const easeOut = 1 - Math.pow(1 - progress, 3);
        currentNumber = targetNumber * easeOut;
        
        if (decimalPlaces > 0) {
          currentNumber = parseFloat(currentNumber.toFixed(decimalPlaces));
        } else {
          currentNumber = Math.floor(currentNumber);
        }
        
        let displayText = currentNumber.toString();
        if (hasDecimal && !displayText.includes('.')) {
          displayText = currentNumber.toFixed(decimalPlaces);
        }
        contentSpan.textContent = displayText;
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // Ensure final value is exact
          let finalText = targetNumber.toString();
          if (hasDecimal) {
            finalText = targetNumber.toFixed(decimalPlaces);
          }
          contentSpan.textContent = finalText;
        }
      };
      
      animate();
    }
  
    animateText(contentSpan, targetText, animDuration) {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const startTime = Date.now();
      const duration = animDuration * 1000;
      let lastUpdate = 0;
      const updateInterval = 50;
      
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const now = Date.now();
        
        if (now - lastUpdate >= updateInterval || progress >= 1) {
          let randomText = '';
          const revealedChars = Math.floor(progress * targetText.length);
          
          for (let i = 0; i < targetText.length; i++) {
            if (i < revealedChars) {
              randomText += targetText[i];
            } else {
              randomText += letters[Math.floor(Math.random() * letters.length)];
            }
          }
          
          contentSpan.textContent = randomText;
          lastUpdate = now;
        }
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          contentSpan.textContent = targetText;
        }
      };
      
      animate();
    }
  }
  customElements.define('animated-title', AnimatedTitle);
}
  